import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import styles from "./SearchResult.module.css";
import removeSpacesFromUrl from "../../helpers/removeSpacesFromUrl";

// Here we create a component for 1 search result so we can map over this later
const SearchResult = ({ id, dsVersion, titleTemplate, active }) => {
  const [titleSpecsheetURL, setTitleSpecsheetUrl] = useState("");

  // Here we set the name of the specsheet to be displayed in the url
  useEffect(() => {
    setTitleSpecsheetUrl(removeSpacesFromUrl(titleTemplate));
  }, [titleTemplate]);

  return (
    <div className={styles["search-result-container"]}>
      <NavLink
        to={`/specsheet/${active}/${id}/${titleSpecsheetURL}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {titleTemplate}
        <span className={styles["ds-version"]}>{" (DS" + dsVersion + ")"}</span>
      </NavLink>
    </div>
  );
};

export default SearchResult;
